import { PayloadAction } from '@reduxjs/toolkit';
import { handleResponseError, handleResponseMessage } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { CommonResponse } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import menuService from './menuService';
import { menuListActions } from './menuSlice';
import { MenuClassification, MenuCsv, MenuDetail, SearchMenuFilter } from './models/menu';

function* getListOfMenuDetail(action: PayloadAction<SearchMenuFilter>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Array<MenuDetail>> = yield call(menuService.getMenuDetailList, params);
    yield put(menuListActions.fetchListOfMenuDetailSuccess(response));
  } catch (e) {
    yield put(menuListActions.fetchListOfMenuDetailFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* deleteMenu(action: PayloadAction<Array<number>>) {
  try {
    const params = action.payload;
    const response: CommonResponse<null> = yield call(menuService.deleteMenu, params);
    yield put(menuListActions.deleteMenuSuccess(true));
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    yield put(menuListActions.deleteMenuFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* restoreMenu(action: PayloadAction<number>) {
  try {
    const params = action.payload;
    const response: CommonResponse<null> = yield call(menuService.restoreMenu, params);
    yield put(menuListActions.restoreMenuSuccess(true));
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    yield put(menuListActions.restoreMenuFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* getMenuClassification(action: PayloadAction<void>) {
  try {
    const response: CommonResponse<Array<MenuClassification>> = yield call(menuService.getMenuClassification);
    yield put(menuListActions.fetchMenuClassificationSuccess(response));
  } catch (e) {
    yield put(menuListActions.fetchMenuClassificationFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* importMenuList(action: PayloadAction<Array<MenuCsv>>) {
  try {
    const params = action.payload;
    const response: CommonResponse<null> = yield call(menuService.postMenuList, params);
    yield put(menuListActions.postMenuSuccess(response));
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    yield handleResponseError(e as AxiosError);
  }
}

export default function* menuListSaga() {
  yield takeLatest(menuListActions.fetchListOfMenuDetail.type, getListOfMenuDetail);
  yield takeLatest(menuListActions.deleteMenu.type, deleteMenu);
  yield takeLatest(menuListActions.fetchMenuClassification.type, getMenuClassification);
  yield takeLatest(menuListActions.postMenu.type, importMenuList);
  yield takeLatest(menuListActions.restoreMenu.type, restoreMenu);
}
